module.exports = __webpack_public_path__ + "img/umy.ad57bc39.png";